import styled from 'styled-components'

import Accordion from '@totallymoney/ui/components/Accordion'
import Heading from '@totallymoney/ui/components/Heading'
import Stack from '@totallymoney/ui/components/Stack'
import Text from '@totallymoney/ui/components/Text'

export const StyledFaqAccordion = styled(Accordion)`
    background-color: white;
`

export const StyledFaqContentStack = styled(({ children, ...rest }) => (
    <Stack space="space20" {...rest}>
        {children}
    </Stack>
))``

export const StyledFaqText = styled(({ children, ...rest }) => (
    <Text color="light" {...rest}>
        {children}
    </Text>
))``

export const StyledFaqSubHeading = styled(({ children, ...rest }) => (
    <Heading variant="20" {...rest}>
        {children}
    </Heading>
))``
